var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box fl"},[_c('div',{staticClass:"line"},[_c('el-divider')],1),_c('div',{staticClass:"tu"},[_c('div',{ref:"university",staticClass:"chart-class",staticStyle:{"width":"100%","height":"100%"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }